import { AutogenModelTariffRegionZip, AutogenRowTariffRegionZip } from "./autogen/AutogenModelTariffRegionZip";

export class ModelTariffRegionZip extends AutogenModelTariffRegionZip<RowTariffRegionZip> {
	constructor() {
		super(RowTariffRegionZip);
	}
}

export class RowTariffRegionZip extends AutogenRowTariffRegionZip {
}